"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TikTokSocialLink1Schema = void 0;
exports.TikTokSocialLink1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/tiktok-sociallink/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "TikTokSocialLink1",
    "description": "Add a link to a TikTok profile",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "const": "rrn:content:ext:services:tiktok-sociallink:1"
        },
        "attributes": {
            "type": "object",
            "properties": {
                "tiktokUser": {
                    "type": "string",
                    "description": "e.g. '@redbull'",
                    "pattern": "^@[a-zA-Z0-9_.]+$"
                }
            },
            "required": [
                "tiktokUser"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy90aWt0b2stc29jaWFsbGluay8xLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLHVCQUF1QixHQUFHO0lBQ3JDLEtBQUssRUFBRSxzRkFBc0Y7SUFDN0YsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsbUJBQW1CO0lBQzVCLGFBQWEsRUFBRSxnQ0FBZ0M7SUFDL0MsTUFBTSxFQUFFLFFBQVE7SUFDaEIsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsT0FBTyxFQUFFLDhDQUE4QztTQUN4RDtRQUNELFlBQVksRUFBRTtZQUNaLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFlBQVksRUFBRTtnQkFDWixZQUFZLEVBQUU7b0JBQ1osTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLGFBQWEsRUFBRSxpQkFBaUI7b0JBQ2hDLFNBQVMsRUFBRSxtQkFBbUI7aUJBQy9CO2FBQ0Y7WUFDRCxVQUFVLEVBQUU7Z0JBQ1YsWUFBWTthQUNiO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLFlBQVk7UUFDWixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=